import { CommonModule } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { TourMatMenu } from 'ngx-ui-tour-md-menu';
import { CommitmentValueWidgetComponent } from '../commitment-value-widget/commitment-value-widget.component';
import { KeyPerformanceWidgetComponent } from '../key-performance-widget/key-performance-widget.component';
import { RemainingValueWidgetComponent } from '../remaining-value-widget/remaining-value-widget.component';
import { SeriesDashboardSummaryComponent } from '../series-dashboard-summary/series-dashboard-summary.component';
import { SeriesDealsTableComponent } from '../series-deals-table/series-deals-table.component';
import { SeriesQRollTableComponent } from '../series-qroll-table/series-qroll-table.component';
import { SeriesSummaryCardComponent } from '../series-summary-card/series-summary-card.component';
import { PortfolioSeriesDashboard } from 'src/app/models/classes/portfolio-series-dashboard.class';
import { ActivityTrackingService } from 'src/app/services/activity-tracking.service';
import { SnapshotService } from 'src/app/services/snapshot.service';

@Component({
  selector: 'app-series-dashboard-private-equity',
  imports: [
    CommonModule,
    TourMatMenu,
    SeriesDashboardSummaryComponent,
    CommitmentValueWidgetComponent,
    RemainingValueWidgetComponent,
    KeyPerformanceWidgetComponent,
    SeriesSummaryCardComponent,
    SeriesDealsTableComponent,
    SeriesQRollTableComponent
  ],
  templateUrl: './series-dashboard-private-equity.component.html'
})
export class SeriesDashboardPrivateEquityComponent {

  snapService = inject(SnapshotService);
  private activityTracking = inject(ActivityTrackingService);

  // input
  readonly dashboardData = input.required<PortfolioSeriesDashboard>();
  readonly investorId = input<number | undefined>(undefined);
  readonly seriesId = input<number | undefined>(undefined);
  readonly reportingPeriod = input<string>('');
  
  readonly iconSet = input.required<Record<string, string>>();
  readonly selectedAsOfDate = input.required<string>();

  readonly seriesNameForBreadcrumb = input.required<string>();
  readonly hidePrivatePublicTab = input<boolean>(false);

  //computed
  readonly investmentTypes = computed(() => this.dashboardData()?.investmentTypes ?? {});
  readonly widgets = computed(() => this.dashboardData()?.widgets);
  readonly summary = computed(() => this.dashboardData()?.summary);
  readonly isAggregatedSeries = computed(() => this.summary()?.underlyingPortfolioSeries?.length > 0);
  readonly isPortfolioSeriesDataUnavailable = computed(() => !this.summary()?.commitment);
  readonly portfolioSummary = computed(() => this.dashboardData()?.displayPortfolioDetail);
  readonly currency = computed(() => this.portfolioSummary()?.currency ?? 'USD');
  readonly otherSectorNames = computed(() => this.dashboardData()?.otherSectorNames ?? []);
  readonly seriesSummary = computed(() => this.dashboardData()?.summary);

  getSnapshot() {
    const seriesId = this.seriesId() ?? 0;
    this.activityTracking.downloadSnapshot(seriesId, this.seriesNameForBreadcrumb());
    const fileName = 'SeriesSnapshot_' + this.portfolioSummary()?.name.replace(/\s/g, "_") + '_' + this.seriesNameForBreadcrumb().replace(/\s/g, "_") + '_' + this.selectedAsOfDate + '.pdf'
    this.snapService.getSnapshot(this.reportingPeriod(), fileName, this.investorId() as number, seriesId);
  }
}
